import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../app/store'
import { CaseConfig, columnMap, FieldMappingConfig, splCharConfigList } from '../../models/app.interface'



const initialCase: CaseConfig = {
    case1: [""]
}
const initialcolumnMap: columnMap = {
    fieldName: ''
}

const initilalFieldMappingConfig: FieldMappingConfig = {
    entityName: [initialcolumnMap]
}


export const initialState: splCharConfigList = {
    entityList: [initilalFieldMappingConfig],
    caseList: [initialCase]
}


export const SplCharRestrictionEntitySlice = createSlice({
    name: 'SplCharRestrictionEntity',
    initialState,
    reducers: {
        setSplCharResEntityDetailsData: (state: splCharConfigList, action: PayloadAction<splCharConfigList>) => {
            state = Object.assign(state, action.payload);
        },
        resetSplCharResEntityDetailsData: (state: splCharConfigList, action: PayloadAction<splCharConfigList>) => {
            state = { ...initialState, ...action.payload };
        },
    }
});

export const { setSplCharResEntityDetailsData, resetSplCharResEntityDetailsData } = SplCharRestrictionEntitySlice.actions;
export const getSplCharResEntityDetails = (state: RootState) => state.SplCharResEntityList;
export default SplCharRestrictionEntitySlice.reducer;

